import { styled } from "styled-components";

export const TabsContainer = styled.div`
    display: flex;
    background: #fff;
    justify-content: flex-end;
    margin-bottom: 27px;
`;

export const TabList = styled.div`
    display: flex;
    border-radius: 61px;
    background: #f4f4f4;
    position: relative;
    width: 410px;
    justify-content: space-between;
`;

interface TabButtonProps {
    active: boolean;
}

export const TabButton = styled.button<TabButtonProps>`
    position: relative;
    color: ${({ active }) => (active ? "#fff" : "#000")};
    cursor: pointer;
    height: 40px;
    padding: 0 30px;
    transition: color 0.3s ease-in-out;
    border: none;
    border-radius: 61px;
    font-size: 14px;
    background: transparent;
    z-index: 2;
`;

export const BackgroundHighlight = styled.div<{ left: number; width: number }>`
    position: absolute;
    height: 40px;
    border-radius: 61px;
    background: #777778;
    transform: translateX(${({ left }) => left}px);
    width: ${({ width }) => width}px;
    z-index: 1;
`;
